import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Dumbbell, Moon, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function IncludesSection() {
  const features = [{
    icon: BookOpen,
    title: 'Guía de 30 Capítulos',
    desc: 'Una lectura diaria diseñada para reprogramar tu subconsciente paso a paso.'
  }, {
    icon: Dumbbell,
    title: 'Ejercicios Prácticos',
    desc: 'No nos quedamos en la teoría. Cada día tiene una acción clara para realizar.'
  }, {
    icon: Moon,
    title: 'Técnicas de SATS y Revisión',
    desc: 'Métodos exactos para usar antes de dormir y transformar tu día.'
  }, {
    icon: ShieldCheck,
    title: 'Acceso Inmediato y de por vida',
    desc: 'Recibes el archivo PDF en tu correo apenas realizas la compra.'
  }];
  return <div className="bg-white" data-id="element-79">
      <Section data-id="element-80">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy text-center mb-16" data-id="element-81">
          ESTE VIAJE INCLUYE:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-82">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center p-6 rounded-xl hover:bg-cream/50 transition-colors duration-300" data-id="element-83">
              <div className="w-16 h-16 mx-auto bg-sage/10 rounded-full flex items-center justify-center mb-6 text-sage-dark" data-id="element-84">
                <feature.icon size={32} strokeWidth={1.5} data-id="element-85" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3 font-heading" data-id="element-86">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-87">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>
      </Section>
    </div>;
}